// App-wide constants

// ─── App / Providers ──────────────────────────────────────────────────────────

/** Hover delay (ms) before a tooltip opens. */
export const TOOLTIP_DELAY_MS = 300

// ─── Data fetching (React Query) ──────────────────────────────────────────────

/** How long (ms) fetched data is considered fresh before a refetch. */
export const QUERY_STALE_TIME_MS = 30_000
/** How long (ms) unused data stays in the cache. */
export const QUERY_GC_TIME_MS = 5 * 60_000
/** Max retries for failed queries (client errors are never retried). */
export const QUERY_MAX_RETRIES = 2

// ─── Data table ───────────────────────────────────────────────────────────────

/** Page-size options in the table footer; the first one is the default. */
export const TABLE_PAGE_SIZES = [10, 20, 50] as const

// ─── Auth module ──────────────────────────────────────────────────────────────

/** Number of digits in the login verification code. */
export const OTP_LENGTH = 6
/** Seconds a user must wait before requesting another code. */
export const OTP_RESEND_COOLDOWN_SECONDS = 30

// ─── Dashboard module ─────────────────────────────────────────────────────────

/** Number of recently edited projects shown under "Continue working". */
export const DASHBOARD_RECENT_PROJECTS_LIMIT = 4

// ─── Projects module ──────────────────────────────────────────────────────────

/** How long (ms) each design shows on a project card before sliding to the next. */
export const PROJECT_CARD_SLIDE_MS = 3500

// ─── Create project module ────────────────────────────────────────────────────

/** Largest file accepted by the project upload step, in megabytes. */
export const UPLOAD_MAX_FILE_MB = 50

// ─── Mock data ────────────────────────────────────────────────────────────────

/** Simulated network delay (ms) for mock API responses, so loading states are visible in development. */
export const MOCK_LATENCY_MS = 400
